import ActionButton from "#/components/buttons/ActionButton";
import { Modal } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export interface ImageLightboxProps {
  src: string | null;
  alt?: string;
  opened: boolean;
  onClose: () => void;
}

const ImageLightbox = ({ src, alt, opened, onClose }: ImageLightboxProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened && !!src}
      onClose={onClose}
      fullScreen
      withCloseButton={false}
      padding={0}
      overlayProps={{ blur: 8, backgroundOpacity: 0.45 }}
      transitionProps={{ transition: "fade", duration: 150 }}
      classNames={{ content: "bg-transparent! shadow-none!", body: "h-full" }}
    >
      <div className="relative w-full h-full flex items-center justify-center p-8" onClick={onClose}>
        <div className="absolute top-4 right-4 z-10">
          <ActionButton
            icon={IconX}
            variant="outline"
            color="white"
            size="xl"
            className="bg-black/40! hover:bg-white! hover:text-black! transition-all duration-200"
            aria-label={t("common.close")}
            onClick={onClose}
          />
        </div>
        {src && (
          <img
            src={src}
            alt={alt ?? ""}
            className="max-w-full max-h-full object-contain select-none rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </div>
    </Modal>
  );
};

export default ImageLightbox;
